export default __webpack_public_path__ + "static/media/museum.cee0cb06.svg";